module.exports = __webpack_public_path__ + "img/OBCINA SENTILJ.7fca58e9.png";